import { useState } from 'react';
import { useTranslation } from 'react-i18next';

const useGrid = () => {
	const { t } = useTranslation();

	const numberOfFields = 10;
	return useState<any>([
		[
			{ value: t('common.firstName'), width: 100, readOnly: true },
			{ value: t('common.lastName'), width: 100, readOnly: true },
			{ value: t('common.userName'), width: 100, readOnly: true },
			{ value: t('common.email'), width: 100, readOnly: true },
			{ value: t('common.employee.mayUseApplicationFrom'), width: 200, readOnly: true },
			{ value: t('common.language.title'), width: 100, readOnly: true },
			{ value: t('common.externalSystemReference'), width: 300, readOnly: true },
			{ value: t('common.group.type.Department'), width: 300, readOnly: true },
			{ value: t('common.settings.jobs.jobPositions.startDate'), width: 300, readOnly: true },
			{ value: t('common.jobTitle'), width: 300, readOnly: true },
			{ value: 'Ready for upload', width: 100, readOnly: true },
			{ value: t('common.status.title'), width: 100, readOnly: true },
		],
		...Array(50).fill([
			...Array(numberOfFields).fill({}),
			{ value: 'Nee', readOnly: true },
			{ value: 'Unsaved', readOnly: true },
		]),
	]);
};

export default useGrid;
